module.exports = __webpack_public_path__ + "img/mouse.1c0cc7ba.jpg";